import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const List = (): AxiosPromise<{ documents: Types.IApi.Document[] }> => {
  return http.request.get<{ documents: Types.IApi.Document[] }>('/reference/documents/assessment');
};
